import { Dialog } from '@headlessui/react';
import { forwardRef, JSX } from 'react';

import { CloseIcon } from '~components/icons/CloseIcon';
import { Button } from '~modules/media-library/view/Button';

type DeleteConfirmModalPanelProps = {
  isLoading: boolean;
  onClose?: () => void;
  onDelete: () => void;
};

export const DeleteConfirmModalPanel = forwardRef<
  HTMLDivElement,
  JSX.IntrinsicElements['div'] & DeleteConfirmModalPanelProps
>(function DeleteConfirmModalPanel({ onClose, onDelete, isLoading, className, ...TheirProps }, ref) {
  return (
    <div
      className={`ml--detail-modal--panel bg-white overflow-y-auto rounded-md shadow-xl w-full max-w-lg min-h-0 max-h-full flex flex-col relative ${
        className ? className : ''
      }`}
      {...TheirProps}
      ref={ref}
    >
      <header className="ml--detail-modal--panel-header flex pl-3 py-2 pr-8">
        <Dialog.Title
          as="h2"
          className="ml--detail-modal--title font-semibold text-base leading-snug overflow-hidden overflow-ellipsis p-0 m-0 h-10 clamp-2"
        >
          Do you really want to delete this file?
        </Dialog.Title>
      </header>
      <Button variant="icon" className="absolute top-0 right-0 border-none" onClick={onClose}>
        <CloseIcon />
      </Button>

      {isLoading ? (
        <>
          <div className="loading"></div>
        </>
      ) : null}
      {!isLoading ? (
        <>
          <div className="flex my-4 justify-center">
            <button className="button c-button c-button--light u-padding-horizontal-lg mx-2" onClick={onClose}>
              Cancel
            </button>
            <button className="button c-button c-button--dark u-padding-horizontal-lg mx-2" onClick={onDelete}>
              Delete
            </button>
          </div>
        </>
      ) : null}
    </div>
  );
});
